var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66683 1.39168L2.7335 0.333344L16.6668 14.2667L15.6085 15.3333L13.0418 12.7667C12.0835 13.0833 11.0668 13.25 10.0002 13.25C5.8335 13.25 2.27516 10.6583 0.833496 7.00001C1.4085 5.53334 2.32516 4.24168 3.49183 3.21668L1.66683 1.39168ZM10.0002 4.50001C10.6632 4.50001 11.2991 4.7634 11.7679 5.23224C12.2368 5.70108 12.5002 6.33697 12.5002 7.00001C12.5002 7.29168 12.4502 7.57501 12.3585 7.83334L9.16683 4.64168C9.42516 4.55001 9.7085 4.50001 10.0002 4.50001ZM10.0002 0.75001C14.1668 0.75001 17.7252 3.34168 19.1668 7.00001C18.4835 8.73334 17.3252 10.2333 15.8335 11.325L14.6502 10.1333C15.7835 9.35001 16.7168 8.28334 17.3502 7.00001C15.9752 4.20001 13.1335 2.41668 10.0002 2.41668C9.09183 2.41668 8.20016 2.56668 7.36683 2.83334L6.0835 1.55834C7.2835 1.04168 8.6085 0.75001 10.0002 0.75001ZM2.65016 7.00001C4.02516 9.80001 6.86683 11.5833 10.0002 11.5833C10.5752 11.5833 11.1418 11.525 11.6668 11.4083L9.76683 9.50001C8.57516 9.37501 7.62516 8.42501 7.50016 7.23334L4.66683 4.39168C3.84183 5.10001 3.15016 5.98334 2.65016 7.00001Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClosed);
export default __webpack_public_path__ + "static/media/eyeClosed.e8fd68f0018072daa60251b6a6098fa2.svg";
export { ForwardRef as ReactComponent };